/**
 * Показывать ли кнопку «Автоматически завершить ход» при планировании
 * строительства в чужой ход (ConstructionPlanAutoCompleteTurnButton в Footer).
 *
 * Временно скрыта; чтобы вернуть — поставить true. Флаг автозавершения
 * выставляет только эта кнопка, поэтому без нее план в начале хода просто
 * применяется, а ход не завершается сам. Само планирование не меняется.
 */
export const IS_CONSTRUCTION_PLAN_AUTO_COMPLETE_TURN_BUTTON_SHOWN = false;
